import { type FC, memo } from 'react';
import './styles.css';
import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';

const BareRedoIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper width='16' height='17' {...props}>
    <path
      d='M0 9.535a6.507 6.507 0 016.5-6.5H11V0l3.535 3.535L11 7.071V4.035H6.5A5.5 5.5 0 107 15.013v1a6.507 6.507 0 01-7-6.478z'
      fill='currentColor'
      className='svgicon__hover-hide'
    />
    <path
      d='M0 9.535a6.507 6.507 0 016.5-6.5H12V0l3.535 3.535L12 7.071V4.035H6.5A5.5 5.5 0 107 15.013v1a6.507 6.507 0 01-7-6.478z'
      fill='currentColor'
      className='svgicon__hover-show'
    />
  </SvgWrapper>
);
export const RedoIcon = memo(BareRedoIcon);
